export const paymentStatuses = [
    {
        id: 1,
        title: "در انتظار تایید",
        icon: "fa-solid fa-circle-check",
        style: "st-1"
    },
    {
        id: 2,
        title: "تایید شده",
        icon: "fa-solid fa-circle-check",
        style: "st-1"
    },
    {
        id: 3,
        title: "درحال آماده سازی",
        icon: "fa-solid fa-circle-check",
        style: "st-1"
    },
    {
        id: 4,
        title: "درحال ارسال",
        icon: "fa-solid fa-circle-check",
        style: "st-1"
    },
    {
        id: 5,
        title: "تحویل داده شده",
        icon: "fa-solid fa-circle-check",
        style: "st-1"
    },
    {
        id: 6,
        title: "لغو شده",
        icon: "fa-solid fa-circle-xmark",
        style: "st-1"
    }
]